import Request from "./Request";

const DevToolService = {
    async lightspeedPopulateMissingDataFilesForLastMonth() {
        return await Request.get('/api/dev-tools/lightspeed/create-missing-last-month-data-files')
    },

    async getPlanToolLocations(clientId) {
        return await Request.get('/api/dev-tools/plans/locations', { client_id: clientId })
    },

    async runPlanToolAction(data) {
        return await Request.post('/api/dev-tools/plans/run', data)
    },
}

export default DevToolService